import React from 'react'
import "./Details.css"
import { Button } from '@material-ui/core'
function Details({title , description , institution , achievement}) {
    return (
        <div className="details">
            <div className="detailsTitle">
                <span>{title}</span>
            </div>
            <div className="detailsDescription">
                <p><span className="detailsInstutuionName">{institution}</span>{achievement}</p>
                <p>{description}</p>
            </div>
            <Button  className="mainBody_contact">Hire me</Button>
            <Button className="mainBody_hire"> projects</Button>
        </div>
    )
}

export default Details
